<nz-table
  #basicTable
  [nzShowPagination]="options.showPagination"
  [nzShowSizeChanger]="options.showPageSizeChanger"
  [nzData]="data"
  [nzBordered]="true"
  [nzSize]="'middle'"
  [nzTotal]="data?.length"
  [nzPageSize]="options.pageSize"
  [nzPageIndex]="pageIndex"
  (nzPageSizeChange)="onPageSizeChange($event)"
  (nzPageIndexChange)="onPageIndexChange($event)"
>
  <thead>
    <tr>
      <!-- Dynamically render the header columns -->
      <th *ngFor="let column of columns" scope="col" [ngStyle]="column.headerStyles">
        @if(column._config?.displayInColumn) {
        <ng-template
          *ngTemplateOutlet="
            CommonGenericFields;
            context: { $implicit: { column, row: columns, isColumn: true } }
          "
        ></ng-template>
        }
        <ng-container>
          <div class="d-flex align-items-center"><span>{{ column.display_name }}</span>
            <span
              *ngIf="column.display_name === 'Feedback'"
              class="ms-2 feedback-tooltip"
            >
              <mat-icon
                class="border-icon"
                [matTooltip]="
                  '👍 Quick approval, no feedback needed.\n👎 Requires comments—help us refine your test case'
                "
                matTooltipPosition="right"
                matTooltipClass="feedback-tooltip"
              >
                info_outline
              </mat-icon>
            </span></div>
        </ng-container>
      </th>
    </tr>
  </thead>

  <tbody>
    @for (row of displayData; track row) {
    <tr>
      <td
        *ngIf="options.isExpandable"
        [nzShowExpand]="row.isExpandable"
        [(nzExpand)]="row.expand"
        (nzExpandChange)="onExpandChange(row.row_id, $event)"
      ></td>

      <td
        *ngFor="let column of columns"
        [hidden]="column.key === 'row_expand'"
        [ngStyle]="{ 'white-space': 'pre-line' }"
        (dblclick)="enableEdit(row, column.key)"
      >
        <div>
          <ng-container
            *ngIf="
              editingCell?.rowId === row.row_id ||
                (editingCell?.rowId === row.testCaseId &&
                  editingCell?.columnKey === column.key);
              else viewMode
            "
          >
            <textarea
              class="form-control"
              style="white-space: pre-line; resize: none"
              [value]="getNestedData(row, column.key)"
              (blur)="saveEdit(row, column.key, $event)"
              autofocus
            ></textarea>
          </ng-container>

          <ng-template #viewMode>
            <ng-container [ngSwitch]="column.key">
              @if(column._config) {
              <ng-template
                *ngTemplateOutlet="
                  CommonGenericFields;
                  context: { $implicit: { column, row, isColumn: false } }
                "
              ></ng-template>
              } @else {
              <ng-container>
                <span style="white-space: pre-line">{{
                  getNestedData(row, column.key)
                }}</span>
              </ng-container>
              }
            </ng-container>
          </ng-template>
        </div>
      </td>
    </tr>
    <tr [nzExpand]="expandSet.has(row.row_id)">
      <span *ngIf="row.expandedContent?.type === 'plain-text'" class="mx-5">{{
        row.expandedContent.content
      }}</span>
    </tr>
    }
  </tbody>
</nz-table>

<!-- GENERIC FIELDS -->
<ng-template #CommonGenericFields let-data>
  <label *ngIf="data.column._config?.label">
    {{ data.column._config?.label }}
  </label>
  <ng-container [ngSwitch]="data.column?._config?.type">
    <!-- Checkbox column header -->
    <ng-container *ngSwitchCase="'checkbox'">
      @if(data.isColumn) {
      <input
        type="checkbox"
        [checked]="isAllChecked"
        [indeterminate]="isIndeterminate"
        (change)="onSelectAll($event)"
      />
      } @else {
      <input
        type="checkbox"
        [(ngModel)]="data.row.select"
        (ngModelChange)="onRowSelectChange()"
      />
      }
    </ng-container>

    <!-- Icon -->
    <ng-container *ngSwitchCase="'icon'">
      @if(data.column._config?.isCondional) {
      <ng-container
        *ngIf="
          data.column._config?.targetKey &&
            data.row[data.column._config?.targetKey];
          else noTargetKey
        "
      >
        <div class="d-flex align-items-center">
          <mat-icon
            class="d-flex align-items-center"
            [ngClass]="{ 'clickable-item': data.column._config?.isClickable }"
            [ngStyle]="
              data.column._config?.value[
                data.row[data.column._config?.targetKey].toLowerCase()
              ]?.iconStyles
            "
            (click)="emitAction(data.column._config?.type, data)"
            (keydown)="emitAction(data.column._config?.type, data)"
          >
            {{
              data.column._config?.value[
                data.row[data.column._config?.targetKey].toLowerCase()
              ]?.value
            }}
          </mat-icon>
          <span *ngIf="data.column._config?.targetKey != 'download_report'"
            >{{ data.row[data.column.key] }}
          </span>
          <!-- DEV NOTE: Below need to be optimized to be dynamic/reusable -->
          <span
            *ngIf="data.column._config?.targetKey == 'download_report'"
            class="download"
            (click)="emitAction(data.column._config?.type, data)"
            (keydown)="emitAction(data.column._config?.type, data)"
          >
            Download Report
          </span>
        </div>
      </ng-container>

      <ng-template #noTargetKey>
        <mat-icon
          [ngClass]="{ 'clickable-item': data.column._config?.isClickable }"
          [ngStyle]="
            data.column._config?.value[data.row[data.column.key]]?.iconStyles
          "
          (click)="emitAction(data.column._config?.type, data)"
          (keydown)="emitAction(data.column._config?.type, data)"
        >
          {{ data.column._config?.value[data.row[data.column.key]]?.value }}
        </mat-icon>
      </ng-template>

      } @else{
      <mat-icon
        (click)="emitAction(data.column._config?.type, data)"
        (keydown)="emitAction(data.column._config?.type, data)"
        [ngClass]="{ 'clickable-item': data.column._config?.isClickable }"
      >
        {{ data.column._config.value }}
      </mat-icon>
      }
    </ng-container>

    <!-- Button -->
    <ng-container *ngSwitchCase="'conditional-button'">
      @if((data.column._config?.conditionalCheck &&
      data.row[data.column._config?.conditionalCheck?.key] ===
      data.column._config?.conditionalCheck?.value )) {
      <button
        [ngClass]="
          data.column._config.classNames
            ? data.column._config.classNames
            : 'ant-btn'
        "
        (click)="emitAction(data.column?._config?.type, data)"
      >
        {{ data.column._config.name }}
      </button>
      }
    </ng-container>

    <ng-container *ngSwitchCase="'button'">
      <button
        [ngClass]="
          data.column._config.classNames
            ? data.column._config.classNames
            : 'ant-btn'
        "
        (click)="emitAction(data.column?._config?.type, data)"
      >
        {{ data.column._config.name }}
      </button>
    </ng-container>

    <!-- Input -->
    <ng-container *ngSwitchCase="'input'">
      <input
        class="form-control"
        [type]="data.column._config?.inputType || 'text'"
        [ngClass]="data.column._config?.classNames"
        [placeholder]="data.column._config?.placeholder || ''"
        [(ngModel)]="data.row[data.column.key]"
        (change)="emitAction(data.column._config?.type, data)"
      />
    </ng-container>

    <!-- Select dropdown -->
    <ng-container *ngSwitchCase="'select'">
      <select
        class="form-select"
        [ngClass]="data.column._config?.classNames"
        [(ngModel)]="data.row[data.column.key]"
        (change)="emitAction(data.column._config?.type, data)"
      >
        <option
          [value]="item.value"
          *ngFor="let item of data.column._config?.options"
        >
          {{ item.label }}
        </option>
      </select>
    </ng-container>

    <!-- Textarea -->
    <ng-container *ngSwitchCase="'textarea'">
      <textarea
        class="form-control"
        [ngClass]="data.column._config?.classNames"
        [placeholder]="data.column._config?.placeholder || ''"
        [(ngModel)]="data.row[data.column.key]"
        (change)="emitAction(data.column._config?.type, data, $event)"
        (blur)="emitAction(data.column._config?.type, data, $event, 'blur')"
      >
      </textarea>
    </ng-container>

    <!-- Feedback with thubms up/down -->
    <ng-container *ngSwitchCase="'thumb-feedback'">
      <div class="d-flex flex-row">
        <mat-icon
          *ngFor="let icon of data.column._config?.value; let i = index"
          (click)="emitAction(data.column._config?.type, data, i)"
          [ngClass]="{
            'clickable-item': data.column._config?.isClickable,
            'thumbs-up-clicked':
              data.row.iconClicked === i && icon === 'thumb_up',
            'thumbs-down-clicked':
              data.row.iconClicked === i && icon === 'thumb_down'
          }"
          [ngStyle]="data.column._config?.iconStyles"
          (keydown.enter)="emitAction(data.column._config?.type, data, i)"
        >
          {{ icon }}
        </mat-icon>
      </div>
      <textarea
        *ngIf="data.row.feedbackEnabled === true"
        class="form-control"
        [ngClass]="data.column._config?.classNames"
        [placeholder]="data.column._config?.placeholder || ''"
        [(ngModel)]="data.row[data.column.key]"
        (change)="emitAction(data.column._config?.type, data, $event)"
        (blur)="emitAction(data.column._config?.type, data, $event, 'blur')"
      >
      </textarea>
    </ng-container>

    <!-- Context menu - data populates by row expansion level -->
    <ng-container *ngSwitchCase="'contextMenuByLevel'">
      <mat-icon
        class="clickable-item"
        [ngStyle]="data.column._config?.iconStyles"
        [matMenuTriggerFor]="contextMenuByLevelMenu"
      >
        {{ data.column._config.icon }}
      </mat-icon>
      <mat-menu #contextMenuByLevelMenu="matMenu">
        <button
          (click)="
            emitAction(
              data.column._config?.type,
              data,
              $event,
              'click',
              menu.value
            )
          "
          mat-menu-item
          *ngFor="let menu of data.column._config?.options[data.row.level]"
        >
          {{ menu.label }}
        </button>
      </mat-menu>
    </ng-container>

    <!-- Image -->
    <ng-container *ngSwitchCase="'image'">
      @if(data.column._config?.isConditional) {
      <div>
        <img
          [src]="
            data.column._config?.value[data.row[data.column._config?.targetKey]]
              ?.value
          "
          [alt]="data.row[data.column._config?.targetKey]"
          [ngStyle]="
            data.column._config?.value[data.row[data.column._config?.targetKey]]
              ?.style
          "
        />
      </div>
      }
    </ng-container>

    <!-- Lozenge -->
    <ng-container *ngSwitchCase="'lozenge'">
      <span
        *ngIf="data.row[data.column.key]"
        class="badge general-text-5 custom-badge badge-secondary"
        [ngClass]="data.column._config.classMapping?.[data.row[data.column.key]]"
        [ngStyle]="data.column._config.style"
      >
        {{ data.row[data.column.key] }}
      </span>
    </ng-container>

    <!-- Section Dropdown -->
    <ng-container *ngSwitchCase="'section_dropdown'">
      <app-dropdown-with-sections
        [selectedValue]="data.row[data.column._config?.targetKey]"
        [config]="data.column._config.componentInputs?.config"
        [fields]="data.column._config.componentInputs?.fields"
        (onSelect)="
          emitAction(data.column._config?.type, data, $event, '', $event)
        "
      >
      </app-dropdown-with-sections>
    </ng-container>

    <!-- Grouped fields -->
    <ng-container *ngSwitchCase="'group'">
      <div class="row">
        <ng-container *ngFor="let field of data.column._config?.fields">
          <div
            [ngClass]="
              getGroupClassName(data.column._config?.fields, field.wrapperClass)
            "
          >
            <label *ngIf="field.label"> {{ field.label }} </label>
            <ng-container [ngSwitch]="field.type">
              <!-- Input -->
              <ng-container *ngSwitchCase="'input'">
                <input
                  class="form-control"
                  [type]="field.inputType || 'text'"
                  [ngClass]="field.classNames"
                  [placeholder]="field.placeholder || ''"
                  [(ngModel)]="field.value"
                  (change)="emitAction(field.type, data)"
                />
              </ng-container>

              <!-- Select dropdown -->
              <ng-container *ngSwitchCase="'select'">
                <select
                  class="form-select"
                  [ngClass]="field.classNames"
                  [(ngModel)]="field.value"
                  (change)="emitAction(field.type, data)"
                >
                  <option
                    [value]="item.value"
                    *ngFor="let item of field.options"
                  >
                    {{ item.label }}
                  </option>
                </select>
              </ng-container>

              <!-- Image -->
              <ng-container *ngSwitchCase="'image'">
                @if(field.isConditional) {
                <div>
                  <img
                    [src]="field.value[data.row[field.targetKey]]?.value"
                    [alt]="field.value[data.row[field.targetKey]]?.value"
                    [ngStyle]="field.value[data.row[field.targetKey]]?.style"
                  />
                </div>
                }
              </ng-container>
            </ng-container>
          </div>
        </ng-container>
      </div>
    </ng-container>
  </ng-container>
</ng-template>
